import breakpoints from '../styles/variables/exports/breakpoints.scss?module'

export default {
  // Default export is a Vue plugin
  install (Vue) {
    // Read more about instance properties on https://vuejs.org/v2/cookbook/adding-instance-properties.html#Base-Example
    Vue.prototype['$viewport'] = {
      _vm: new Vue({
        // The REACTIVE global data
        data: () => {
          return {
            viewports: ['xs', 'sm', 'md', 'lg', 'xl'],
            mediaQueries: {
              smAndUp: null,
              mdAndUp: null,
              lgAndUp: null,
              xlAndUp: null,
            },
            current: 'xs',
            viewportsBelowCurrent: [],
            xs: true,
            sm: false,
            md: false,
            lg: false,
            xl: false,
            xsAndUp: true,
            smAndUp: false,
            mdAndUp: false,
            lgAndUp: false,
            xlAndUp: false,
          }
        },
        watch: {
          current: function(current) {
            // get all viewports below the current viewport
            this.viewportsBelowCurrent = this.getViewportsBelow(current)
          },
        },
        created () {
          if (process.server) return // catch if Nuxt tries to do this on the server
          this.initiateMediaQueries()
        },
        beforeDestroy () {
          if (process.server) return // catch if Nuxt tries to do this on the server
          for (const viewport in this.mediaQueries) {
            this.mediaQueries[viewport].removeListener(this.getMatches)
          }
        },
        methods: {
          async initiateMediaQueries () {
            this.mediaQueries = {
              smAndUp: window.matchMedia(`(min-width: ${breakpoints.sm})`),
              mdAndUp: window.matchMedia(`(min-width: ${breakpoints.md})`),
              lgAndUp: window.matchMedia(`(min-width: ${breakpoints.lg})`),
              xlAndUp: window.matchMedia(`(min-width: ${breakpoints.xl})`),
            }

            // manually trigger once
            this.getMatches()
            
            // listen when a query changes
            for (const viewport in this.mediaQueries) {
              this.mediaQueries[viewport].addListener(this.getMatches)
            }
          },
          getMatches () {
            this.xsAndUp = true
            this.smAndUp = this.mediaQueries.smAndUp.matches
            this.mdAndUp = this.mediaQueries.mdAndUp.matches
            this.lgAndUp = this.mediaQueries.lgAndUp.matches
            this.xlAndUp = this.mediaQueries.xlAndUp.matches
            this.xs = !this.smAndUp
            this.sm = this.smAndUp && !this.mdAndUp
            this.md = this.mdAndUp && !this.lgAndUp
            this.lg = this.lgAndUp && !this.xlAndUp
            this.xl = this.xlAndUp

            // save the currently active viewport
            for (const viewport of this.viewports) {
              if (this[viewport]) {
                this.current = viewport
              }
            }
          },
          getViewportsBelow (breakpoint) {
            const breakpointIndex = this.viewports.indexOf(breakpoint)
            return this.viewports.filter((viewport, index) => {
              return index < breakpointIndex
            }).reverse()
          },
          parseOptions (options) {
            if (typeof options === 'string' && options.includes(':')) {
              const entries = options.toString().split(/\s(?=xs:|sm:|md:|lg:|xl:)/g)
              let isCorrectSyntax = true
              const optionsObject = entries.reduce((obj, entry) => {
                const viewportAndValue = entry.split(':')
                if (this.viewports.some(prefix => viewportAndValue[0] === prefix)) {
                  obj[`${viewportAndValue[0]}AndUp`] = viewportAndValue[1]
                } else {
                  isCorrectSyntax = false
                }
                return obj
              }, {})
              if (isCorrectSyntax) {
                return optionsObject
              }
            }
            return options
          },
          switch (options, specificBreakpoint) {
            /**
             * options: String "xs:value sm:value md:value" or Object {xs: value, sm: value, md: value}
             * specificBreakpoint: String "xs" or "xsAndUp"
             */
            if (!options) return
            options = this.parseOptions(options)
            if (typeof options === 'object') {
              let breakpoint = specificBreakpoint || this.current
              breakpoint = breakpoint.replace('AndUp', '')
              const viewport = `${breakpoint}AndUp`
              if (options[viewport] === undefined) {
                // no option given for the current viewport
                // so find next smaller viewport option
                for (const viewportBelow of this.getViewportsBelow(breakpoint)) {
                  if (options[`${viewportBelow}AndUp`] !== undefined) {
                    return options[`${viewportBelow}AndUp`]
                  }
                }
                return null
              } else {
                // option given for the current viewport
                return options[viewport]
              }
            }
            return options
          },
        },
      }),
      switch (options, specificBreakpoint) {
        return this._vm.switch(options, specificBreakpoint)
      },
      parseOptions (options) {
        return this._vm.parseOptions(options)
      },
      get xs () {
        return this._vm.$data.xs
      },
      get xsAndUp () {
        return this._vm.$data.xsAndUp
      },
      get sm () {
        return this._vm.$data.sm
      },
      get smAndUp () {
        return this._vm.$data.smAndUp
      },
      get md () {
        return this._vm.$data.md
      },
      get mdAndUp () {
        return this._vm.$data.mdAndUp
      },
      get lg () {
        return this._vm.$data.lg
      },
      get lgAndUp () {
        return this._vm.$data.lgAndUp
      },
      get xl () {
        return this._vm.$data.xl
      },
      get xlAndUp () {
        return this._vm.$data.xlAndUp
      },
      get current () {
        return this._vm.$data.current
      },
      get all () {
        return this._vm.$data.viewports
      },
    }
  },
}
